import React from 'react';
import FaIcon from './FaIcon';
import InputWithClear from './InputComponents/InputWithClear';
import ErrorMessage from './ErrorMessage';

export default class DataWithInPlaceEdit extends React.Component
{
  static defaultProps = {
    dataToShow: 'Something',
    serviceFunction: null,
    value: null,
    type: null,
    clickOnSave: null,
    editEnabled: true,
  };

  constructor (props)
  {
    super(props);
    this.state = {
      dataEdited: false,
      value: null,
    };
  }

  componentDidMount () { }

  renderNotEdited ()
  {
    return (
      <div>
        {this.props.dataToShow}
        {this.props.serviceFunction && this.props.editEnabled && (
          <FaIcon
            iconName='fa-solid fa-pen'
            className='m-1 border rounded p-1 text-info pointer'
            onClick={() => this.setState({ dataEdited: true, value: this.props.value })}
          />
        )}
      </div>
    );
  }

  renderCancelButton ()
  {
    return (
      <button
        className='btn btn-sm btn-danger m-1'
        onClick={() => this.setState({ dataEdited: false })}
      >
        <FaIcon iconName='fa-solid fa-xmark' />
      </button>
    );
  }
  renderOkButton ()
  {
    return (
      <button
        className='btn btn-sm btn-success m-1'
        onClick={() =>
        {
          this.setState({ dataEdited: false });
          this.props
            .serviceFunction(this.state.value)
            .then((result) =>
            {
              if (result.error)
              {
                ErrorMessage.SetErrorMessage(result.error);
                return;
              }
              this.props.clickOnSave();
            })
            .catch((error) => ErrorMessage.SetErrorMessage(error));
        }}
      >
        <FaIcon iconName='fa-solid fa-check' />
      </button>
    );
  }

  renderEdited ()
  {
    return (
      <div className='text-center'>
        <InputWithClear
          type={this.props.type}
          value={this.state.value}
          labelIsDisabled={true}
          onChange={(field, newValue) => this.setState({ value: newValue })}
          fieldName='selectedSubstitution'
        />
        {this.renderCancelButton()}
        {this.renderOkButton()}
      </div>
    );
  }

  render ()
  {
    if (!this.state.dataEdited)
    {
      return this.renderNotEdited();
    }
    return this.renderEdited();
  }
}
